import React from 'react'
import PropTypes from 'prop-types'

import Select from 'react-select'

import Asterisk from '../Asterisk'
import FieldError from '../FieldError'
import Badge from '../Badge'

// const options = [
//   { value: 'male', label: 'MALE' },
//   { value: 'female', label: 'FEMALE' },
// ]

const MultiSelectInput = ({
  required,
  label,
  name,
  values,
  errors,
  touched,
  readOnlyChips,
  className = '',
  // inputClassName = '',
  disabled = false,
  readOnly = false,
  onChange = () => { },
  onBlur = () => { },
  isMulti = true,
  isClearable = false,
  options = [],
  description = '',
  // size,
  popover = null,
  inline = false,
  labelWidth = 6,
  inputWidth = 6,
  defaultValue = null,
  dataPrivate = true
}) => {
  // let sizeClass = '';
  // if (size === 'lg') {
  //   sizeClass = 'form-select-lg';
  // } else if (size === 'sm') {
  //   sizeClass = 'form-select-sm';
  // }

  let containerClassName = `form-group col-12 rounded ${className}`
  if (!disabled && !readOnly && errors[name] && touched[name]) {
    containerClassName += ' has-danger'
  }
  if (readOnly) {
    containerClassName += ' bg-light-hover read-only'
  }
  if (inline) {
    containerClassName += ' row'
  }

  let labelClassName = 'form-label'
  if (inline) {
    labelClassName += ` col-12 col-sm-${labelWidth}`
    if (readOnly) {
      labelClassName += ' mb-0'
    }
  } else {
    labelClassName += ' mb-0'
  }

  return (
    <div className={containerClassName}>
      <label htmlFor={name} className={labelClassName}>
        {label}{readOnly && ':'}{required && <Asterisk />}{popover}
      </label>
      <div className={`${inline ? `col-12 col-sm-${inputWidth}` : ''}`} data-private={dataPrivate}>
        {readOnly
          ? readOnlyChips
            ? (
              <div className='lh-lg'>
                {readOnlyChips.map((d, i) => (
                  <Badge
                    key={i}
                    chip
                    variant={d.variant}
                    onClick={d.onClick}
                    className='me-2'
                  >
                    {d.label}
                  </Badge>
                ))}
              </div>
            )
            : <span>{values[name].map((d) => d.label).join(', ')}</span>
          : (
            <>
              <Select
                id={name}
                // className={`form-select ${sizeClass} ${inputClassName}`}
                classNames={{
                  container: () => 'react-select-container',
                  control: () => 'react-select-control',
                  menu: () => 'rounded',
                  multiValue: () => 'react-select-multivalue',
                  multiValueRemove: () => 'react-select-multivalue-remove'
                }}
                aria-label={description || name}
                aria-required={required}
                name={name}
                isDisabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                value={values[name]}
                isClearable={isClearable}
                isMulti={isMulti}
                options={options}
                defaultValue={defaultValue}
              />
              <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />
            </>
          )
        }
      </div>
    </div>
  )
}

MultiSelectInput.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  readOnlyChips: PropTypes.arrayOf(PropTypes.any),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
  placeholder: PropTypes.string,
  description: PropTypes.string,
  inline: PropTypes.bool,
  labelWidth: PropTypes.number,
  inputWidth: PropTypes.number,
  popover: PropTypes.any,
  defaultValue: PropTypes.object,
  dataPrivate: PropTypes.bool
}

export default MultiSelectInput
